

import { DataGroup } from "../dataGroup.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class DataGroupTeamSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new DataGroup();
        this._copyAttributesValue(gp, data);
        return gp;

    }

}
